const GIA_LAB_SHAPE_DATA = [
    {
        "LAB_SHAPE": "CUSHION BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUSHION MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUT-CORNERED RECTANGULAR MIXED CUT"
    },
    {
        "LAB_SHAPE": "CUT-CORNERED RECTANGULAR MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "CUT-CORNERED SQUARE MIXED CUT"
    },
    {
        "LAB_SHAPE": "CUT-CORNERED SQUARE MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "EMERALD CUT"
    },
    {
        "LAB_SHAPE": "HALF-MOON MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "HEART BRILLIANT"
    },
    {
        "LAB_SHAPE": "HEXAGONAL MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "MARQUISE BRILLIANT"
    },
    {
        "LAB_SHAPE": "MODIFIED HEXAGONAL STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED OVAL STEP CUT"
    },
    {
        "LAB_SHAPE": "MODIFIED RECTANGULAR BRILLIANT"
    },
    {
        "LAB_SHAPE": "OLD EUROPEAN BRILLIANT"
    },
    {
        "LAB_SHAPE": "OLD MINE BRILLIANT"
    },
    {
        "LAB_SHAPE": "OVAL BRILLIANT"
    },
    {
        "LAB_SHAPE": "PEAR BRILLIANT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "RECTANGULAR STEP CUT"
    },
    {
        "LAB_SHAPE": "ROUND BRILLIANT"
    },
    {
        "LAB_SHAPE": "ROUND MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "SQUARE EMERALD CUT"
    },
    {
        "LAB_SHAPE": "SQUARE MODIFIED BRILLIANT"
    },
    {
        "LAB_SHAPE": "TRAPEZOID STEP CUT"
    }
]

export default GIA_LAB_SHAPE_DATA;